module.exports = __webpack_public_path__ + "media/images/version_merge/doc_upload_user-afa88c630476c9ac4de9a4742cf0b4f1.png";